import React from "react";
import About from "./Landing/components/About";
import ProblemSolution from "./Landing/components/ProblemSolution";
import Hero from "./Landing/components/Hero";
import Numbers from "./Landing/components/Numbers";
import News from "./Landing/components/News";
import Footer from "./Landing/components/Footer";
import Assets from "./Landing/components/Assets";

const Landing = (props) => {
  return (
    <>
      <Hero />
      <About />
      <Assets {...props}/>
      <Numbers />
      <ProblemSolution />
      <News/>
      <Footer/>
    </>
  );
};

export default Landing;
